export enum BarcodePrimaryCode {
  MEDIUM_BARCODE = "1",
  ID_BARCODE = "3",
  WATER_BARCODE = "6",
}

export const BarcodePrimaryCodeDisplayName: Record<BarcodePrimaryCode, string> = {
  [BarcodePrimaryCode.MEDIUM_BARCODE]: 'Medium-Barcode',
  [BarcodePrimaryCode.ID_BARCODE]: 'ID-Barcode',
  [BarcodePrimaryCode.WATER_BARCODE]: 'Wasser-Barcode',
};

export const BarcodePrimaryCodeOptions: { label: string; value: BarcodePrimaryCode }[] = [
  { label: BarcodePrimaryCodeDisplayName[BarcodePrimaryCode.MEDIUM_BARCODE], value: BarcodePrimaryCode.MEDIUM_BARCODE },
  { label: BarcodePrimaryCodeDisplayName[BarcodePrimaryCode.ID_BARCODE], value: BarcodePrimaryCode.ID_BARCODE },
  { label: BarcodePrimaryCodeDisplayName[BarcodePrimaryCode.WATER_BARCODE], value: BarcodePrimaryCode.WATER_BARCODE },
];
